var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import http from 'app/services/http';
import moment from 'moment';
import { getLivePoster, publishLivePoster, subscribeLivePoster } from '../livePoster';
import { VIDEO_VENDORS } from '../vendors';
/**
 * Dahua adapter: live via Node (StartVideo + go2rtc MSE/WebRTC on substream).
 * Preview tiles: one-shot JPEG from control API (go2rtc frame.jpeg) — no WebRTC per tile.
 */
export const dahuaAdapter = {
    vendor: VIDEO_VENDORS.DAHUA,
    supportsPreviewStreams: false,
    supportsPreviewPosters: true,
    supportsArchive: true,
    requiresFlvJs: false,
    skipPosterFetchWhenSelected: true,
    deferPreviewsUntilLivePoster: true,
    previewKickTimeoutMs: 1400,
    retryLiveOnTransientError: true,
    livePosterBus: {
        publish: publishLivePoster,
        get: getLivePoster,
        subscribe: subscribeLivePoster,
    },
    getChannels() {
        return [];
    },
    getLivePlayback(params) {
        return __awaiter(this, void 0, void 0, function* () {
            if (params.transportId == null) {
                throw new Error('Dahua live requires transportId');
            }
            const { data } = yield http.post(`/map/transport/${params.transportId}/broadcast/live`, {
                channelId: params.channelId,
            });
            return {
                kind: data.kind,
                url: data.url,
                isLive: true,
                sourceCodec: data.sourceCodec,
                strategy: data.strategy,
                streamName: data.streamName,
                channelId: data.channelId || params.channelId,
                deviceId: data.deviceId || params.deviceId,
                fallback: data.fallback
                    ? {
                        kind: data.fallback.kind,
                        url: data.fallback.url,
                        isLive: true,
                        strategy: data.fallback.strategy,
                    }
                    : undefined,
            };
        });
    },
    getArchivePlayback(params) {
        return __awaiter(this, void 0, void 0, function* () {
            if (params.transportId == null) {
                throw new Error('Dahua archive requires transportId');
            }
            const { data } = yield http.post(`/map/transport/${params.transportId}/broadcast/archive`, {
                channelId: params.channelId,
                positionSeconds: params.positionSeconds,
                from: moment(params.selectedDate[0]).format('YYYY-MM-DD HH:mm:ss'),
                to: moment(params.selectedDate[1]).format('YYYY-MM-DD HH:mm:ss'),
            });
            return {
                kind: data.kind,
                url: data.url,
                isLive: false,
                sourceCodec: data.sourceCodec,
                strategy: data.strategy,
                streamName: data.streamName,
                channelId: data.channelId || params.channelId,
                deviceId: data.deviceId || params.deviceId,
                fallback: data.fallback
                    ? {
                        kind: data.fallback.kind,
                        url: data.fallback.url,
                        isLive: false,
                        strategy: data.fallback.strategy,
                    }
                    : undefined,
            };
        });
    },
    getPreviewPlayback(_params) {
        return __awaiter(this, void 0, void 0, function* () {
            return null;
        });
    },
    getPreviewPosterUrl(params) {
        if (params.transportId == null) {
            return null;
        }
        return `/map/transport/${params.transportId}/broadcast/preview?channelId=${encodeURIComponent(String(params.channelId))}`;
    },
    releaseLive(_a) {
        return __awaiter(this, arguments, void 0, function* ({ transportId, streamName }) {
            if (!streamName) {
                return;
            }
            try {
                yield http.post(`/map/transport/${transportId}/broadcast/live/release`, { streamName });
            }
            catch (_b) {
                // best-effort
            }
        });
    },
    getEventLabel(type) {
        return String(type);
    },
};
